'use strict';

angular.module('AcaApp').controller('SendMfaController', [
  '$scope',
  '$window',
  '$location',
  '$rootScope',
  'AuthenticationService',
  'AuxiliaryDataService',
  'ManagedUserInformationService',
  'SettingsService',
  function($scope, $window, $location, $rootScope, AuthenticationService, AuxiliaryDataService, ManagedUserInformationService, SettingsService){
    $scope.errorMessage = '';
    $scope.phoneNumber = $window.sessionStorage.phoneNumber;
    $scope.showMainReturnToLoginButton = false;
    $scope.tooMuchAttemptsWarning = '';

    $scope.showReturnEditPhoneButton = function(){
      return ($window.sessionStorage.fromAddPhone === 'true');
    }

    $scope.getAttempsCount = function(){
      AuthenticationService.getOTPAttemptCount().then(function(response){
        if(response.result.value >= 3) 
          $scope.tooMuchAttemptsWarning = 'WARNING: You have '+(5-response.result.value)+' attempt'+(5-response.result.value > 1? 's': '')+' to set a valid code, then your user will be locked.';
      });
    };

    if($window.sessionStorage.MFAToken){
      $scope.getAttempsCount();
    };

    $scope.sendOtpCode = function(code){
      if($window.sessionStorage.MFAToken){
        $scope.sendOtpCodeWithToken(code);
      }
      else{
        $scope.sendOtpCodeWithoutToken(code);
      }
    };

    $scope.sendOtpCodeWithToken = function(code){
      $scope.errorMessage = '';
      AuthenticationService.verifyMFATokenWithoutSession(code).then(function(response){
        if(response.result.value){
          $window.sessionStorage.token = response.result.value;
          $scope.settingsAfterLogin();
        }
        else{
          $scope.errorMessage = 'There was an unexpected issue.';
        }
      })
      .catch(function(error) {
        $scope.handleError(error, 'There was a problem trying to validate code.');
      });
    };

    $scope.sendOtpCodeWithoutToken = function(code){
      $scope.errorMessage = '';
      AuthenticationService.verifyMFATokenWithSession(code).then(function(response){
        if(response.result.value){
          $scope.settingsAfterLogin();
        }
        else{
          $scope.errorMessage = 'The code you enter is not valid.';
        }
      })
      .catch(function(){        
        $scope.errorMessage = 'There was a problem trying to validate code.';      
      })
    };

    $scope.settingsAfterLogin = function(){
      $rootScope.userVerified = true;
      ManagedUserInformationService.findClient();
      $window.sessionStorage.secondsLeft = $window.sessionStorage.sessionExpireSetting;
      AuthenticationService.setSessionInterval();
      
      SettingsService.getTaxYears().then(function(data){
        $window.localStorage['TaxYears'] = data.result.value;
        $window.localStorage['FirstTimeTaxYears'] = true;
        $scope.taxYears = $window.localStorage['TaxYears'].split(',');
      });

      if($window.sessionStorage.eulaAccepted === 'false'){
        $location.path('/license-agreement');
      }
      else{
        AuxiliaryDataService.LoadCountryList();
        $location.path('/home');
        AuthenticationService.checkEmailToApprove();
      }
    };

    $scope.resendOTP = function(){
      $scope.errorMessage = '';
      $scope.codeMfa = '';
      if($window.sessionStorage.MFAToken){
        AuthenticationService.resendOTPToken().then(function(response){
          if(!response.result.value){
            $scope.errorMessage = 'There was a problem trying to resend the code, please try again.';
          }
        })
        .catch(function(error){ 
          $scope.handleError(error, 'There was a problem trying to send code.');
        });     
      }
      else{
        AuthenticationService.resendOTP().then(function(response){
          if(!response.result.value){
            $scope.errorMessage = 'There was a problem trying to resend the code, please try again.';
          }
        })
        .catch(function(error){
          $scope.errorMessage = 'There was a problem trying to send code.';
        })        
      }
    };

    $scope.returnToLogin = function(){
      $location.search({});
      AuthenticationService.logout();
    };

    $scope.returnToAddPhone = function(){
      if($window.sessionStorage.MFAToken){
        AuthenticationService.validateMFAToken().then(function(response){
          $location.path('/add-phone');
        })
        .catch(function(error){
          $scope.handleError(error, 'There was a problem trying to redirect.')
        });
      }
      else{
        $location.path('/add-phone');
      }
    };

    $scope.handleError = function(error, defaultErrorMessage){
      switch(error.data.error.frontend_code){
        case 'INVALID_CODE':
          $scope.errorMessage = error.data.error.frontend_message;
          $scope.getAttempsCount();
          break;
    
        case 'EXPIRED_MFATOKEN':
          $scope.errorMessage = error.data.error.frontend_message;
          $scope.showMainReturnToLoginButton = true;
          break;

        case 'USER_LOCKED':
          $scope.errorMessage = error.data.error.frontend_message;
          $scope.showMainReturnToLoginButton = true;
          $scope.tooMuchAttemptsWarning = '';
          break;
    
        default:
          $scope.errorMessage = defaultErrorMessage;
          $scope.getAttempsCount();
      }
    };
  }
]);